import { useEffect } from "react";
import { useDispatch, useSelector } from "src/store";
import { cancelAppointment } from "src/store/appointment";

export function useCancelReservedBooking() {
    const dispatch = useDispatch();
    const siteId = useSelector(state => state.appointment.clinicId);
    const reservedBooking = useSelector(state => state.appointment.reservedBooking);

    useEffect(()=>{
        if(reservedBooking) {
            dispatch(cancelAppointment({siteId, appointmentId: reservedBooking.appointment_id, isPendingCancel: true}));
        }
    },[dispatch, reservedBooking, siteId]);
}